import { Component, Input } from '@angular/core';
import { ViewportService } from 'app/core/services/viewport.service';

@Component({
  selector: 'fts-order-notification-upsell-done-message',
  templateUrl: './order-notification-upsell-done-message.component.html',
  styleUrls: ['./order-notification-upsell-done-message.component.scss'],
})
export class OrderNotificationUpsellDoneMessageComponent {
  @Input()
  message: string;

  constructor(public viewportService: ViewportService) {}
}
